export default class User {
  static from (data) {
    try {
      if (!data) {
        return null
      }
      let obj = JSON.parse(data)
      return new User(obj)
    } catch (e) {
      console.log('error', e)
      return null
    }
  }

  constructor ({ user_id, email, is_admin, name, slack_user, roles, avatar, custom_notifications, default_mailbox_id, message_signature, covered_users, filtered_teams, message_redirect, fields_order, preferred_boards }) { // eslint-disable-line camelcase
    this.id = user_id // eslint-disable-line camelcase
    this.email = email
    this.name = name
    this.slackUser = slack_user // eslint-disable-line camelcase
    this.roles = roles
    this.avatar = avatar
    this.customNotifications = custom_notifications // eslint-disable-line camelcase
    this.defaultMailboxId = default_mailbox_id // eslint-disable-line camelcase
    this.messageSignature = message_signature // eslint-disable-line camelcase
    this.covered_users = covered_users // eslint-disable-line camelcase
    this.filtered_teams = filtered_teams // eslint-disable-line camelcase
    this.message_redirect = message_redirect // eslint-disable-line camelcase
    this.fields_order = fields_order // eslint-disable-line camelcase
    this.preferred_boards = preferred_boards // eslint-disable-line camelcase
  }
}



// WEBPACK FOOTER //
// ./src/models/User.js